import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Container, Grid, Typography, useMediaQuery } from '@mui/material'
import { useDispatch } from 'react-redux'
import CookiesStorageService from '../../services/CookiesStorageService'
import AppRoutes from '../../services/AppRoutes'
import ResponsiveAppBar from '../../components/ResponsiveAppBar'
import { userAuthValidateToken } from '../../redux/features/userAuth/userAuthThunk'
import { getFirstAndSecondCharacterOnly, getUserName, isNotEmpty } from '../../utils/helpers'
import landingInfo from '../../images/landing-info.icon.png'
import landingModules from '../../images/landing-modules-icon.png'
import UserInfoSide from './UserInfoSide'
import ModulesSide from './ModulesSide'
import UseTranslation from '../../hooks/UseTranslation'
import { getTenantAssets } from '../../utils/tenantHelper'
import HoverTooltip from '../../components/PageHelpers/HoverTooltip'
import TitleWithIcon from '../../components/Cards/helpers/TitleWithIcon'
import SubscriptionReminder from '../../components/SubscriptionReminder'

const Index = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'))
  const { t } = UseTranslation()
  const { displayName, logoUrl } = getTenantAssets()
  const subscriptionReminder = CookiesStorageService.getSubscriptionReminder()
  const subscriptionReminderVisible = isNotEmpty(subscriptionReminder)
  useEffect(() => {
    dispatch(userAuthValidateToken())

    if (CookiesStorageService.getUserModules()?.length === 1) {
      const userModuleName = CookiesStorageService.getUserModules()[0].name
      if (userModuleName === 'Eds') {
        window.location.href = process.env.REACT_APP_EDS_FRONTEND_URL
      } else if (userModuleName === 'Recruitment') {
        window.location.href = process.env.REACT_APP_RECRUITMENT_FRONTEND_URL
      } else if (userModuleName === 'Self Service') {
        window.location.href = `${process.env.REACT_APP_SELF_FRONTEND_URL}`
      } else if (userModuleName === 'core') {
        window.location.href = `${process.env.REACT_APP_CORE_FRONTEND_URL}/`
      } else if (userModuleName === 'Admin') {
        history.push(AppRoutes.landing)
      }
    }
  }, [])

  const userName = CookiesStorageService.getUserName()
  return (
    <Box sx={styles.root}>
      <ResponsiveAppBar />
      <Container sx={styles.container} maxWidth='xl'>

       <SubscriptionReminder
        visible={subscriptionReminderVisible}
        subscriptionReminder={subscriptionReminder}
       />

        <Box sx={styles.titleBox}>
          <Box sx={styles.nameSection}>
            <Box sx={styles.titleShortName}>
              {getFirstAndSecondCharacterOnly(userName)}
            </Box>
            <Typography>
              {t?.Welcome}
              {' '}
              <HoverTooltip title={userName}>
               {getUserName(userName, isSmScreen)}
            </HoverTooltip>
              </Typography>
          </Box>

          <img src={logoUrl} alt={displayName} style={styles.logo} />
        </Box>

        <Grid container sx={styles.DataContainer} spacing={2}>
          <Grid item sm={12} md={8} >
            <TitleWithIcon
            title={t?.['User Information']}
              icon={<img src={landingInfo} alt='admin icon' />}
              customStyle={styles.userInfoTitle}
            />
            <UserInfoSide />
          </Grid>

          <Grid item sm={12} md={4}>
            <TitleWithIcon
            title={t?.['Please Select One Of Your Modules To Login To']}
              icon={<img src={landingModules} alt='admin icon' />}
              customStyle={styles.modulesTitle}
            />
            <ModulesSide />
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

const styles = {
  root: {
    backgroundColor: 'white',
    minHeight: '100vh',
  },
  container: {
    paddingBottom: { xs: '10px', md: '0px' },
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '-10px',
    marginBottom: { xs: '10px', sm: '10px' },
    paddingBottom: { xs: '10px', sm: '15px' },
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    '& img': {
      display: { xs: 'none', sm: 'block' },
      maxWidth: { xs: '80px', sm: '180px', md: '220px' },
      width: '100%',
      height: { xs: '30px', sm: '57px' },
    },
    logo: {
      display: { xs: 'block', sm: 'none' },
      maxWidth: { xs: '80px', sm: '180px', md: '220px' },
      width: '100%',
      height: { xs: '30px', sm: '57px' },
    },

  },
  nameSection: {
    alignItems: 'center',
    display: 'flex',
    m: { xs: '15px 0 5px 0', sm: '0px' },
    '& p': {
      fontSize: { xs: '16px', sm: '28px' },
      fontFamily: 'Avenir-bold',
      textTransform: 'capitalize',
      width: 'max-content',
    },
  },
  titleShortName: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: { xs: '40px', sm: '60px' },
    height: { xs: '40px', sm: '60px' },
    color: 'white',
    borderRadius: '12px',
    fontSize: { xs: '20px', sm: '28px' },
    fontFamily: 'Avenir-bold',
    textTransform: 'uppercase',
    backgroundColor: '#2A374A',
    marginRight: { xs: '5px', sm: '20px' },
  },
  warningBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#FFF3E0',
    borderRadius: '12px',
    padding: { xs: '12px 12px 12px 16px', sm: '12px 16px 12px 20px' },
    marginBottom: { xs: '16px', sm: '20px' },
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    border: '1px solid rgba(237, 108, 2, 0.2)',
  },
  warningBarContent: {
    display: 'flex',
    alignItems: 'flex-start',
    flex: 1,
    minWidth: 0,
  },
  warningIconWrap: {
    position: 'relative',
    marginRight: { xs: '12px', sm: '16px' },
    flexShrink: 0,
    backgroundColor: '#F59E0B',
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
  },
  warningBellIcon: {
    width: 24,
    height: 24,
    color: '#ffffff',
  },
  warningDot: {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#F59E0B',
    flexShrink: 0,
    '@keyframes warningDotPulse': {
      '0%, 100%': { transform: 'scale(1)' },
      '50%': { transform: 'scale(1.2)' },
    },
    animation: 'warningDotPulse 2s ease-in-out infinite',
  },
  warningTextWrap: {
    flex: 1,
    minWidth: 0,
  },
  warningTitleWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '10px',
  },
  warningTitle: {
    fontSize: { xs: '14px', sm: '16px' },
    fontFamily: 'Avenir-bold',
    fontWeight: 700,
    color: '#8B4512',
    lineHeight: 1.2,
  },
  warningTitleSub: {
    fontSize: { xs: '13px', sm: '15px' },
    fontFamily: 'Avenir',
    fontWeight: 400,
    color: '#8B4512',
    lineHeight: 1.2,
  },
  warningMessage: {
    fontSize: { xs: '12px', sm: '14px' },
    color: 'rgba(0,0,0,0.75)',
    lineHeight: 1.45,
    marginTop: '4px',
    paddingLeft: { xs: '0px', sm: '20px' },
  },
  warningCloseBtn: {
    color: 'rgba(0,0,0,0.5)',
    backgroundColor: 'rgba(0,0,0,0.03)',
    borderRadius: '8px',
    marginLeft: 1,
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.1)',
      transform: 'scale(1.1)',
      transition: 'transform 0.6s ease-in-out',
    },
  },
  dismissSnackbar: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: '#e6f7ed',
    color: '#1e7e34',
    borderRadius: '12px',
    padding: '12px 16px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    border: '1px solid rgba(30, 126, 52, 0.25)',
    minWidth: 320,
    maxWidth: 560,
  },
  dismissSnackbarIcon: {
    flexShrink: 0,
    width: 24,
    height: 24,
    color: '#1e7e34',
  },
  dismissSnackbarText: {
    flex: 1,
    fontSize: '14px',
    color: '#1e7e34',
  },
  dismissedBarUndo: {
    fontSize: { xs: '13px', sm: '14px' },
    fontWeight: 600,
    color: '#1e7e34',
    textDecoration: 'underline',
    cursor: 'pointer',
    flexShrink: 0,
    '&:hover': {
      opacity: 0.9,
    },
  },
  userInfoTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'normal', md: 'flex-start' },
    marginLeft: { xs: '0px', sm: '20px' },
    marginBottom: { xs: '10px', sm: '10px' },
    '& img': {
      width: { xs: '15px', sm: '20px' },
    },
    '& p': {
      fontSize: { xs: '14px', sm: '18px' },
    },
  },
  modulesTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'normal', md: 'flex-start' },
    marginLeft: { xs: '0px', sm: '0px' },
    marginBottom: { xs: '10px', sm: '10px' },
    '& img': {
      width: { xs: '15px', sm: '20px' },
    },
    '& p': {
      fontSize: { xs: '14px', sm: '18px' },
    },
  },
  DataContainer: {
    flexDirection: { xs: 'column', md: 'row' },
    mb: { xs: '10px', sm: 'unset' },
    marginTop: { xs: '-3px', sm: '0px' },
  },
}

export default Index
